import { useTranslation } from "@/hooks/useTranslation";

export default function MarketingCheckboxes({
  collectEmailMarketing,
  collectSmsMarketing,
  setEmailMarketing,
  setSmsMarketing,
}: {
  collectEmailMarketing: boolean | null;
  collectSmsMarketing: boolean | null;
  setEmailMarketing: (emailMarketing: boolean) => void;
  setSmsMarketing: (smsMarketing: boolean) => void;
}) {
  const { t } = useTranslation();

  if (!collectEmailMarketing && !collectSmsMarketing) return null;

  return (
    <div className="mt-2 flex flex-col items-start space-y-2">
      {collectEmailMarketing && (
        <div className="flex flex-row items-center space-x-2">
          <input
            id="email-marketing"
            type="checkbox"
            className="h-4 w-4 cursor-pointer rounded border-gray-300 text-black focus:ring-black"
            defaultChecked={collectEmailMarketing}
            onChange={(e) => setEmailMarketing(e.target.checked)}
          />
          <label
            htmlFor="email-marketing"
            className="cursor-pointer text-xs font-medium text-gray-700"
          >
            {t("email_marketing")}
          </label>
        </div>
      )}
      {collectSmsMarketing && (
        <div className="flex flex-row items-center space-x-2">
          <input
            id="sms-marketing"
            type="checkbox"
            className="h-4 w-4 cursor-pointer rounded border-gray-300 text-black focus:ring-black"
            defaultChecked={collectSmsMarketing}
            onChange={(e) => setSmsMarketing(e.target.checked)}
          />
          <label
            htmlFor="sms-marketing"
            className="cursor-pointer text-xs font-medium text-gray-700"
          >
            {t("sms_marketing")}
          </label>
        </div>
      )}
    </div>
  );
}
